import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import Checkbox from '../../controls/Checkbox';

const CheckboxField = ({
  name,
  control,
  rules = {},
  feedback,
  ...restProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <Checkbox
          {...restProps}
          {...restField}
          name={name}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
        />
      )}
    />
  );
};

CheckboxField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default CheckboxField;
